import React from "react";
import { WifiOff, Wifi } from "lucide-react";

interface OfflineBannerProps {
  isOnline: boolean;
  wasOffline: boolean;
}

const OfflineBanner: React.FC<OfflineBannerProps> = ({
  isOnline,
  wasOffline,
}) => {
  if (!isOnline) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white px-4 py-2 text-sm font-medium flex items-center justify-center gap-2 shadow-md print:hidden"
      >
        <WifiOff size={16} aria-hidden="true" />
        You are offline. Some features may be limited.
      </div>
    );
  }

  if (wasOffline) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="fixed top-0 left-0 right-0 z-50 bg-emerald-500 text-white px-4 py-2 text-sm font-medium flex items-center justify-center gap-2 shadow-md animate-pulse print:hidden"
      >
        <Wifi size={16} aria-hidden="true" />
        Connection restored. Syncing latest data...
      </div>
    );
  }

  return null;
};

export default OfflineBanner;
